import styled from 'styled-components';
import Grid from 'styled-components-grid';

export const Container = styled.div`
  margin: 0 auto;
  display: block;
  height: auto;
  max-width: 90%;

  width: 1200px;
  height: 100%;
`;

export const Row = styled(Grid)`
  height: 100%;
  margin-left: -10px;
  margin-right: -10px;
`;

export const Col = styled(Grid.Unit)`
  padding-left: 10px;
  padding-right: 10px;
`;

export const RCol = styled(Col)`
  text-align: right;
`;



// WEBPACK FOOTER //
// ./src/components/Grid.js